import { IItemBranchesModifierValidation } from '../types/itemBranchesModifier';

export enum MODIFIER_COLUMN {
  BRANCH = 'branch',
  OPTION_NAME = 'option_name',
  PRICE = 'price',
  DEFAULT_PRICE = 'default_price',
  AVAILABILITY = 'availability',
}

export const defaultItemBranchesModifierValidation: IItemBranchesModifierValidation = {
  valid: true,
  price: true,
  available: true,
};
